import { FieldValues, Path, useFormContext } from "react-hook-form";
import { Sidebar } from "primereact/sidebar";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DropdownFilterEvent } from "primereact/dropdown";

import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import { useFormDropdownJobGradeContext } from "./form-dropdown-job-grade.context";

export interface FormDropdownJobGradeProps<T extends FieldValues> {
  name: Path<T>;
  allowCreate?: boolean;
}

export function FormDropdownJobGrade<T extends FieldValues>({
  name,
  allowCreate = false,
}: FormDropdownJobGradeProps<T>) {
  const hintText = allowCreate
    ? `Select from the created holidayType dropdown. Otherwise, hit ENTER to create a new holidayType. If the holidayType doesn't exist select N/A`
    : "";
  const { control } = useFormContext<T>();
  const {
    sidebar,
    newJobGrade,
    mappedJobGrade,
    isCreating,
    setSidebar,
    setFilter,
    setNewJobGrade,
    handleFilterInput,
    handleAdd,
  } = useFormDropdownJobGradeContext();
  
  return (
    <div className="job-grade">
      {newJobGrade && (
        <Sidebar visible={sidebar} onHide={() => setSidebar(false)}>
          <h2>Create new jobGrade</h2>
          <p>
            You are creating a new jobGrade. Please, fill the fields to create a
            new jobGrade and apply to current item creation.
          </p>
          <div className="flex flex-col gap-2 mt-4">
            <InputText
              placeholder="JobGrade Name"
              value={newJobGrade.name}
              onChange={(e: any) =>
                setNewJobGrade({ ...newJobGrade, name: e.target.value })
              }
            />
            <InputText
              placeholder="JobGrade Description"
              value={newJobGrade.description}
              onChange={(e: any) =>
                setNewJobGrade({ ...newJobGrade, description: e.target.value })
              }
            />

            <Button
              label="Create"
              onClick={handleAdd}
              className="block"
              disabled={isCreating}
            />
          </div>
        </Sidebar>
      )}
      <DropdownControl<T>
        control={control}
        name={name}
        label="Job Grade"
        options={ mappedJobGrade }
        containerClassName="mb-9"
        className="w-full md:w-3/4"
        placeholder="Enter your job grade"
        hint={hintText}
        filter
        onFilter={(e: DropdownFilterEvent) => setFilter(e.filter)}
        onKeyDown={allowCreate ? handleFilterInput : () => {}}
      />
    </div>
  );
}

export default FormDropdownJobGrade;